"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _EditableTableContext = require("./EditableTableContext");
var _util = require("./../util");
var _EditableCellButton = _interopRequireDefault(require("./EditableCellButton"));
var _ValidationTooltip = _interopRequireDefault(require("./ValidationTooltip"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ykbStyledComponents = require("../../ykb-styled-components");
var _excluded = ["dataIndex", "children", "inputProps", "record", "inputType", "title", "editable", "cellChangeTrigger", "onInputFocus", "onInputBlur", "getInput", "disabled", "viewMode", "isFirstEditable", "isLastEditable", "mapValuesToForm", "save", "cancel", "undoText", "editOnFocus", "cellStyle", "rowIndex", "focusedHighlight", "tooltipProps", "size", "className"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var TdWrapper = _ykbStyledComponents.styled.td.withConfig({
  componentId: "ykb-ui__sc-ypgqcp-0"
})(["background-color:", ";", ""], function (props) {
  return props.$focusedHighlight ? props.theme.color.primary2 : props.theme.color.neutral1;
}, function (props) {
  return props.$customError && (0, _ykbStyledComponents.css)([".input-container{*{border-color:", " !important;&:focus,&.focus{box-shadow:none;}}}.editable-cell-button{border-color:", " !important;}"], function (props) {
    return props.theme.color.danger6;
  }, function (props) {
    return props.theme.color.danger6;
  });
});
var emptyFunc = function emptyFunc() {};
function shouldListenOnChange(input) {
  if (!input) {
    return false;
  }
  /*
  if (input && input.props) {
    if (input.props.prefixCls === 'ykb-select') {
      return true;
    }
  }
  */
  if (input.className) {
    /*
    // new date picker classname
    if (input.className.toString().includes('rc-picker-input')) {
      return true;
    }
    */
    // v3 picker
    if (input.className.toString().includes('-datepicker-input')) {
      return true;
    }
  }
  return false;
}
var SingleEditableCell = function SingleEditableCell(_ref) {
  var dataIndex = _ref.dataIndex,
    children = _ref.children,
    inputProps = _ref.inputProps,
    record = _ref.record,
    inputType = _ref.inputType,
    title = _ref.title,
    editable = _ref.editable,
    cellChangeTrigger = _ref.cellChangeTrigger,
    onInputFocus = _ref.onInputFocus,
    onInputBlur = _ref.onInputBlur,
    getInput = _ref.getInput,
    disabled = _ref.disabled,
    viewMode = _ref.viewMode,
    isFirstEditable = _ref.isFirstEditable,
    isLastEditable = _ref.isLastEditable,
    mapValuesToForm = _ref.mapValuesToForm,
    save = _ref.save,
    cancel = _ref.cancel,
    undoText = _ref.undoText,
    editOnFocus = _ref.editOnFocus,
    cellStyle = _ref.cellStyle,
    rowIndex = _ref.rowIndex,
    focusedHighlight = _ref.focusedHighlight,
    tooltipProps = _ref.tooltipProps,
    size = _ref.size,
    className = _ref.className,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // if cell is not editable just use normal rendering
  if (!editable) {
    return /*#__PURE__*/_react.default.createElement("td", (0, _extends2.default)({}, restProps, {
      className: className
    }), children);
  }
  var _useEditableTableForm = (0, _EditableTableContext.useEditableTableForm)(),
    form = _useEditableTableForm.form,
    editingKey = _useEditableTableForm.editingKey,
    setEditingKey = _useEditableTableForm.setEditingKey,
    selectedDataIndex = _useEditableTableForm.selectedDataIndex,
    setSelectedDataIndex = _useEditableTableForm.setSelectedDataIndex,
    rowKey = _useEditableTableForm.rowKey,
    isRowEditing = _useEditableTableForm.isRowEditing;
  var isRowEditingCheck = focusedHighlight && typeof isRowEditing === 'function' && isRowEditing(record);
  var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndex);
  var _inputRef = (0, _react.useRef)(null);
  var isUndoAction = (0, _react.useRef)(false);
  var init = (0, _react.useRef)(false);
  var customErrorStyle = typeof cellStyle == 'function' ? cellStyle(record, rowIndex) : cellStyle;
  var isDisabled = false;
  if (disabled) {
    if (typeof disabled === 'function') {
      isDisabled = disabled(record);
    } else {
      isDisabled = true;
    }
  }
  var isViewMode = false;
  if (viewMode) {
    if (typeof viewMode === 'function') {
      isViewMode = viewMode(record);
    } else {
      isViewMode = true;
    }
  }
  (0, _react.useEffect)(function () {
    if (isEditing() && !init.current && _inputRef.current) {
      setInputValue();
    }
  }, [editingKey, selectedDataIndex]);
  var setInputValue = function setInputValue() {
    form.current.setFieldsValue(mapValuesToForm((0, _defineProperty2.default)({}, dataIndex, record[dataIndex])));
    if (_inputRef.current.focus) {
      setTimeout(function () {
        onInputFocus(record, dataIndex);
        _inputRef.current.focus();
        // fix masked input elements cursor position
        _inputRef.current.selectionStart = _inputRef.current.selectionEnd = 10000;
      }, 0);
    }
  };
  var getClassName = function getClassName(_ref2) {
    var tableInput = _ref2.tableInput;
    return (0, _classnames.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, "editable-cell-".concat(key, "-").concat(dataIndex), true), 'table-input', !!tableInput), 'editing-cell', true));
  };
  function renderInput() {
    var errors = form.current.getFieldError(dataIndex);
    /**
     * tablo small size ise input'lar yeni xsmall size'ı kullanır,
     * değil ise mevcuttaki gibi small size'ı kullanmaya devam eder
     */
    var inputSize = size === 'small' ? 'xsmall' : 'small';
    var InputCoponent = getInput(dataIndex, record, _objectSpread({
      size: inputSize,
      inputRef: function inputRef(ref) {
        if (ref) {
          _inputRef.current = ref;
        }
      },
      ref: function ref(item) {
        if (!_inputRef.current) {
          _inputRef.current = item;
        }
      },
      onChange: onChange,
      onBlur: onBlur,
      name: dataIndex,
      className: getClassName({
        tableInput: true
      }),
      disabled: isDisabled
    }, inputProps), inputType);
    return /*#__PURE__*/_react.default.createElement(_ValidationTooltip.default, (0, _extends2.default)({}, tooltipProps, {
      errors: errors,
      undo: undo,
      undoText: undoText
    }), InputCoponent);
  }
  function isEditing() {
    var key = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndex);
    return record && key && editingKey === key && selectedDataIndex === dataIndex;
  }
  function onChange(_x) {
    return _onChange.apply(this, arguments);
  }
  function _onChange() {
    _onChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(element) {
      var listenOnChange;
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            listenOnChange = shouldListenOnChange(_inputRef.current);
            if (!(!listenOnChange && !cellChangeTrigger)) {
              _context2.next = 3;
              break;
            }
            return _context2.abrupt("return");
          case 3:
            setTimeout(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee() {
              var value, key;
              return _regenerator.default.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return form.current.validateFields([dataIndex]);
                  case 2:
                    value = _context.sent;
                    key = (0, _util.getRecordKeyByRowKey)(rowKey, record, value);
                    save(key, value);
                  case 5:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            })), 0);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _onChange.apply(this, arguments);
  }
  function onBlur(_x2) {
    return _onBlur.apply(this, arguments);
  }
  function _onBlur() {
    _onBlur = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(e) {
      var value;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return form.current.validateFields([dataIndex]);
          case 2:
            value = _context4.sent;
            setTimeout(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3() {
              var listenOnChange, _key;
              return _regenerator.default.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(isUndoAction.current === true)) {
                      _context3.next = 4;
                      break;
                    }
                    isUndoAction.current = false;
                    _context3.next = 11;
                    break;
                  case 4:
                    listenOnChange = shouldListenOnChange(_inputRef.current);
                    if (!(!listenOnChange && !cellChangeTrigger)) {
                      _context3.next = 9;
                      break;
                    }
                    _key = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndex);
                    _context3.next = 9;
                    return save(_key, value);
                  case 9:
                    init.current = false;
                    onInputBlur(record, dataIndex);
                  case 11:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            })), 0);
          case 4:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    return _onBlur.apply(this, arguments);
  }
  function undo() {
    isUndoAction.current = true;
    cancel();
  }
  function onButtonClick() {
    return _onButtonClick.apply(this, arguments);
  }
  function _onButtonClick() {
    _onButtonClick = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var _key2;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            if (!(form.current && editingKey && selectedDataIndex)) {
              _context5.next = 4;
              break;
            }
            _context5.next = 4;
            return form.current.validateFields([selectedDataIndex]);
          case 4:
            _key2 = (0, _util.getRecordKeyByRowKey)(rowKey, record, dataIndex);
            setEditingKey(_key2);
            setSelectedDataIndex(dataIndex);
            _context5.next = 12;
            break;
          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            console.info('SingleEditableCell onButtonClick does not updates dataIndex and key unless validation completed', _context5.t0);
          case 12:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 9]]);
    }));
    return _onButtonClick.apply(this, arguments);
  }
  function onClick(_x3) {
    return _onClick.apply(this, arguments);
  }
  function _onClick() {
    _onClick = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee6(e) {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            e.preventDefault();
            _context6.next = 3;
            return onButtonClick();
          case 3:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return _onClick.apply(this, arguments);
  }
  var inputClassName = getClassName({
    tableInput: false
  });
  return /*#__PURE__*/_react.default.createElement(TdWrapper, (0, _extends2.default)({}, restProps, {
    $customError: customErrorStyle && customErrorStyle.indexOf('custom-error') > -1,
    $focusedHighlight: isRowEditingCheck,
    className: (0, _classnames.default)(className, {
      'editing-cell': true
    })
  }), record && isEditing() && form.current ? renderInput() : editable ? /*#__PURE__*/_react.default.createElement(_EditableCellButton.default, {
    className: inputClassName,
    onClick: onClick,
    disabled: isDisabled,
    viewMode: isViewMode,
    onFocus: function onFocus() {
      onInputFocus(record, dataIndex);
      editOnFocus && onButtonClick();
    }
  }, children) : children);
};
var _default = exports.default = SingleEditableCell;